import React, { Component } from 'preact';

interface IPageTextProps {
    text: any;
}

class PageText extends Component<IPageTextProps> {
    render() {
        const { text } = this.props;

        if (text) {
            return <span className="page-text" dangerouslySetInnerHTML={{__html: text}}></span>
        }
        return '';
    }
}

export default PageText;
